import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'out-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label = 'Click Me';
  @Input() isLoading = false;
  @Input() disabled = false;
  @Input() buttonClass = '';
  @Input() loadingLabel = 'Loading';
  @Input() type = 'button'
  @Output() clicked = new EventEmitter<void>();

  get classes() {
    return `${this.buttonClass} relative px-4 py-2 rounded transition-all flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed`;
  }

  handleClick() {
    if (!this.isLoading && !this.disabled) {
      this.clicked.emit();
    }
  }
}
